/* Global theme behaviour. Product-only behaviour lives in fuse-pdp.js. */
(function () {
  'use strict';

  /* Format cents using the store's money format (injected as window.wispMoneyFormat),
     mirroring Liquid's `| money` so JS-rendered prices match server-rendered ones. */
  function formatWithDelimiters(cents, precision, thousands, decimal) {
    var parts = (cents / 100).toFixed(precision).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }
  var money = function (cents) {
    var format = window.wispMoneyFormat || '${{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  };

  var scrollLocks = 0;
  function lockScroll() { scrollLocks++; document.body.style.overflow = 'hidden'; }
  function unlockScroll() { scrollLocks = Math.max(0, scrollLocks - 1); if (!scrollLocks) document.body.style.overflow = ''; }

  function trapFocus(container) {
    function handler(e) {
      if (e.key !== 'Tab') return;
      var els = Array.prototype.filter.call(
        container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.hidden && el.getAttribute('aria-hidden') !== 'true' && el.getClientRects().length > 0; }
      );
      if (!els.length) return;
      var first = els[0], last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    return function () { container.removeEventListener('keydown', handler); };
  }

  document.querySelectorAll('.q button').forEach(function (b) {
    b.addEventListener('click', function () {
      var q = b.parentElement;
      var ans = q.querySelector('.ans');
      var open = q.classList.contains('open');
      q.classList.toggle('open');
      b.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (!ans) return;
      if (open) {
        /* Closing: the open state is maxHeight:none (see transitionend below),
           so re-pin to the current pixel height first or the collapse won't animate. */
        ans.style.maxHeight = ans.scrollHeight + 'px';
        void ans.offsetHeight;
        ans.style.maxHeight = null;
      } else {
        ans.style.maxHeight = ans.scrollHeight + 'px';
      }
    });
  });
  /* Once opened, let answers size naturally so viewport resizes / late font
     loads can't clip them against a stale pinned height. */
  document.querySelectorAll('.q .ans').forEach(function (ans) {
    ans.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'max-height' && ans.parentElement.classList.contains('open')) {
        ans.style.maxHeight = 'none';
      }
    });
  });

  var toast = document.getElementById('toast');
  var toastMsg = document.getElementById('toast-msg');
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    if (toastMsg) toastMsg.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2800);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.classList.toggle('show', count > 0);
    });
  }

  var cartOverlay = document.getElementById('cartOverlay');
  var cartBody = document.getElementById('cartBody');
  var cartFoot = document.getElementById('cartFoot');
  var cartSubtotalEl = document.getElementById('cartSubtotal');
  var cartItemsTotalEl = document.getElementById('cartItemsTotal');
  var cartCountLine = document.getElementById('cartCountLine');
  var cartRewards = document.getElementById('cartRewards');
  var cartRewardMessage = document.getElementById('cartRewardMessage');
  var cartRewardMeter = document.getElementById('cartRewardMeter');
  var cartBusy = false;

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) {
    if (!url) return '';
    return url.indexOf('?') > -1 ? url + '&width=' + w : url + '?width=' + w;
  }

  var cartUntrap = null;
  var cartReturnFocus = null;
  function openCart() {
    if (!cartOverlay || cartOverlay.classList.contains('open')) { renderCart(); return; }
    cartOverlay.classList.add('open');
    cartOverlay.setAttribute('aria-hidden', 'false');
    lockScroll();
    cartReturnFocus = document.activeElement;
    var drawer = cartOverlay.querySelector('.cart-drawer') || cartOverlay;
    cartUntrap = trapFocus(drawer);
    setTimeout(function () {
      var closeBtn = document.getElementById('cartClose');
      if (closeBtn && cartOverlay.classList.contains('open')) closeBtn.focus();
    }, 120);
    renderCart();
  }
  function closeCart() {
    if (!cartOverlay || !cartOverlay.classList.contains('open')) return;
    cartOverlay.classList.remove('open');
    cartOverlay.setAttribute('aria-hidden', 'true');
    unlockScroll();
    if (cartUntrap) { cartUntrap(); cartUntrap = null; }
    if (cartReturnFocus && cartReturnFocus.focus) cartReturnFocus.focus();
    cartReturnFocus = null;
  }

  var renderToken = 0;
  function renderCartRewards(cart) {
    if (!cartRewards) return;
    var eligibleHandles = window.WISP_BUNDLE_HANDLES || [];
    var items = (cart && cart.items) || [];
    var allEligibleOneTime = items.length > 0 && items.every(function (item) {
      return eligibleHandles.indexOf(item.handle) !== -1 && !item.selling_plan_allocation;
    });
    var qty = Number(cart && cart.item_count) || 0;
    if (qty < 1 || !allEligibleOneTime) {
      cartRewards.hidden = true;
      return;
    }
    cartRewards.hidden = false;
    var tier = Math.min(qty, 3);
    if (cartRewardMessage) {
      var savings = Number(cart.total_discount || 0);
      if (tier === 3 && savings > 0) {
        cartRewardMessage.textContent = 'You save ' + money(savings) + ' today + free shipping';
      } else {
        cartRewardMessage.innerHTML = (window.WISP_BUNDLE_MESSAGES || {})[tier] || '';
      }
    }
    if (cartRewardMeter) {
      cartRewardMeter.style.setProperty('--reward-progress', tier === 1 ? '0%' : tier === 2 ? '50%' : '100%');
      cartRewardMeter.querySelectorAll('[data-reward-tier]').forEach(function (step) {
        var stepTier = Number(step.getAttribute('data-reward-tier'));
        step.classList.toggle('is-unlocked', stepTier <= tier);
        step.classList.toggle('is-current', stepTier === tier);
      });
    }
  }

  // Cart drawer display helpers: new-label tin art, plain names, and the renewal line.
  var CART_NAMES = {
    'fuse-boost': ['Boost Energy Strips', 'Cranberry'],
    'fuse-vital': ['Vital Iron Strips', 'Raspberry'],
    'fuse-dream': ['Dream Sleep Strips', 'Raspberry']
  };
  function planCadence(item) {
    var a = item.selling_plan_allocation;
    var name = a && a.selling_plan && a.selling_plan.name ? a.selling_plan.name : '';
    var m = /every\s+(?:(\d+)\s+)?months?/i.exec(name);
    return m ? Number(m[1] || 1) : 0;
  }
  function cadenceWords(months) { return months === 1 ? 'month' : months + ' months'; }
  function renewalTotal(item) {
    var a = item.selling_plan_allocation;
    var adj = a && a.price_adjustments;
    var unit = adj && adj.length ? adj[adj.length - 1].price : (a ? a.price : 0);
    return Number(unit) * Number(item.quantity);
  }

  function renderCart() {
    if (!cartBody) return;
    var token = ++renderToken;
    return window.FuseCartQuantity.normalize()
      .then(function (cart) {
        if (token !== renderToken) return;
        updateCartCount(cart.item_count);
        renderCartRewards(cart);
        if (cartCountLine) {
          cartCountLine.textContent = cart.item_count;
          cartCountLine.hidden = cart.item_count < 1;
          cartCountLine.setAttribute('aria-label', cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ' in your cart');
        }
        if (!cart.items || !cart.items.length) {
          var emptyTemplate = document.getElementById('cartEmptyTemplate');
          cartBody.innerHTML = emptyTemplate ? emptyTemplate.innerHTML : '<div class="cart-empty"><p>Your cart is empty.</p><a href="/collections/all">Shop strips</a></div>';
          if (cartFoot) cartFoot.hidden = true;
          return;
        }
        if (cartFoot) cartFoot.hidden = false;
        var subscriptionNote = document.getElementById('cartSubscriptionNote');
        if (subscriptionNote) {
          var subLines = cart.items.filter(function (item) { return item.selling_plan_allocation; });
          subscriptionNote.hidden = !subLines.length;
          if (subLines.length) {
            var cadences = subLines.map(planCadence).filter(function (m, i, all) { return all.indexOf(m) === i; });
            var renewal = subLines.reduce(function (sum, item) { return sum + renewalTotal(item); }, 0);
            subscriptionNote.textContent = cadences.length === 1 && cadences[0] && renewal > 0
              ? 'Then ' + money(renewal) + ' every ' + cadenceWords(cadences[0]) + '. Skip or cancel before your next billing date.'
              : 'Subscription renewal terms are shown at checkout.';
          }
        }
        var WISP_BLURBS = window.WISP_BLURBS || {};
        cartBody.innerHTML = cart.items.map(function (item) {
          var tinArt = (window.FUSE_CART_TINS || {})[item.handle];
          var imgUrl = tinArt || (item.featured_image && item.featured_image.url ? item.featured_image.url : item.image);
          var names = CART_NAMES[item.handle];
          var displayName = names ? names[0] : item.product_title;
          var flavor = names ? names[1] : '';
          var cadence = planCadence(item);
          var purchaseDetails = item.selling_plan_allocation
            ? 'Subscribe & save' + (cadence ? ' · every ' + cadenceWords(cadence) : '')
            : 'One-time purchase';
          var quantityMarkup = '<div class="qty">' +
              '<button type="button" data-act="dec" aria-label="Decrease ' + escapeHtml(item.product_title) + ' quantity">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-act="inc" aria-label="Increase ' + escapeHtml(item.product_title) + ' quantity">+</button>' +
              '</div>';
          var blurb = names ? flavor : (WISP_BLURBS[item.handle] || '');
          var originalLinePrice = Number(item.original_line_price);
          var finalLinePrice = Number(item.final_line_price);
          var linePriceMarkup = (originalLinePrice > finalLinePrice ? '<s class="ci-sub">' + money(originalLinePrice) + '</s><br>' : '') +
            '<span class="ci-price">' + money(finalLinePrice) + '</span>';
          return '' +
            '<div class="cart-line" data-key="' + item.key + '" data-variant-id="' + item.variant_id + '">' +
              '<div class="ci-imgwrap">' +
                '<a class="ci-image-link" href="' + item.url + '" aria-label="View ' + escapeHtml(item.product_title) + '">' +
                  '<img src="' + sized(imgUrl, 132) + '" alt="" width="66" height="66">' +
                '</a>' +
              '</div>' +
              '<div class="ci-main">' +
                '<a class="ci-name" href="' + item.url + '">' + escapeHtml(displayName) + '</a>' +
                (blurb ? '<div class="ci-blurb">' + escapeHtml(blurb) + '</div>' : '') +
                (purchaseDetails ? '<div class="ci-sub">' + escapeHtml(purchaseDetails) + '</div>' : '') +
                quantityMarkup +
              '</div>' +
              '<div class="ci-end">' +
                '<div>' + linePriceMarkup + '</div>' +
                '<button type="button" class="ci-remove" data-act="rm" aria-label="Remove ' + escapeHtml(item.product_title) + ' from cart">Remove</button>' +
              '</div>' +
            '</div>';
        }).join('');
        var freeShip = cart.item_count >= 3;
        renderDiscounts(cart, freeShip);
        if (cartItemsTotalEl) {
          var itemsTotal = cart.original_total_price != null ? cart.original_total_price : cart.total_price + cart.total_discount;
          cartItemsTotalEl.textContent = money(itemsTotal);
        }
        if (cartSubtotalEl) cartSubtotalEl.textContent = money(cart.total_price);
        var checkoutTotal = document.getElementById('cartCheckoutTotal');
        if (checkoutTotal) checkoutTotal.textContent = ' · ' + money(cart.total_price);
      })
      .catch(function () {
        if (token !== renderToken) return;
        if (cartRewards) cartRewards.hidden = true;
        cartBody.innerHTML = '<div class="cart-empty"><p>Couldn&rsquo;t load your cart.</p><a href="/cart">View cart page</a></div>';
        if (cartFoot) cartFoot.hidden = true;
      });
  }

  var cartDiscountsEl = document.getElementById('cartDiscounts');
  function renderDiscounts(cart, freeShip) {
    if (!cartDiscountsEl) return;
    var map = {};
    var order = [];
    function add(title, amount) {
      if (!amount) return;
      var t = title || 'Discount';
      if (map[t] == null) { map[t] = 0; order.push(t); }
      map[t] += amount;
    }
    var fromLines = {};
    (cart.items || []).forEach(function (it) {
      var lineDiscounts = Array.isArray(it.line_level_discount_allocations) ? it.line_level_discount_allocations : (it.discounts || []);
      lineDiscounts.forEach(function (d) {
        var t = d.title || (d.discount_application && d.discount_application.title) || 'Discount';
        fromLines[t] = true;
        add(t, d.amount);
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      var t = d.title || d.description || 'Discount';
      if (!fromLines[t]) add(t, d.total_allocated_amount);
    });
    if (!order.length && !freeShip) { cartDiscountsEl.hidden = true; cartDiscountsEl.innerHTML = ''; return; }
    cartDiscountsEl.hidden = false;
    var discountRows = order.map(function (t) {
      return '' +
        '<div class="cart-disc">' +
          '<span class="cd-name"><span class="cd-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12.6 2.6A2 2 0 0 0 11.2 2H4a2 2 0 0 0-2 2v7.2a2 2 0 0 0 .6 1.4l8.7 8.7a2.4 2.4 0 0 0 3.4 0l6.6-6.6a2.4 2.4 0 0 0 0-3.4z"/><circle cx="7.5" cy="7.5" r="1.2"/></svg></span>' + escapeHtml(String(t).replace(/\bpacks\b/gi, 'tins').replace(/\bpack\b/gi, 'tin')) + '<svg class="cd-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 6.5"/></svg></span>' +
          '<span class="cd-amt">&minus;' + money(map[t]) + '</span>' +
        '</div>';
    }).join('');
    var shippingTemplate = document.getElementById('cartShippingDiscountTemplate');
    var shippingRow = freeShip && shippingTemplate ? shippingTemplate.innerHTML : '';
    cartDiscountsEl.innerHTML = discountRows + shippingRow;
  }

  function changeLine(key, qty, focusAct, variantId) {
    if (cartBusy || window.FuseCartQuantity.isBusy()) return;
    cartBusy = true;
    ++renderToken;
    if (cartBody) cartBody.setAttribute('aria-busy', 'true');
    if (cartCheckout) cartCheckout.setAttribute('aria-disabled', 'true');
    window.FuseCartQuantity.update([{ key: key, quantity: qty }])
      .then(function () {
        // A drawer edit on /cart invalidates the server-rendered quantity inputs.
        if (document.querySelector('[data-cart-page-form]')) window.location.reload();
        return renderCart();
      })
      .then(function () {
        var nextLine = Array.prototype.find.call(cartBody.querySelectorAll('.cart-line'), function (line) {
          return line.getAttribute('data-key') === key || (variantId && line.getAttribute('data-variant-id') === variantId);
        });
        var nextFocus = nextLine && focusAct ? nextLine.querySelector('[data-act="' + focusAct + '"]') : null;
        if (!nextFocus) nextFocus = cartBody.querySelector('.cart-line .ci-name, .cart-empty a') || document.getElementById('cartCheckout') || cartClose;
        if (nextFocus) nextFocus.focus();
      })
      .catch(function (error) { showToast(error.message || 'Could not update cart'); return renderCart(); })
      .finally(function () {
        cartBusy = false;
        if (cartBody) cartBody.removeAttribute('aria-busy');
        if (cartCheckout) cartCheckout.removeAttribute('aria-disabled');
      });
  }

  var cartCheckout = document.getElementById('cartCheckout');
  if (cartCheckout) cartCheckout.addEventListener('click', function (event) {
    event.preventDefault();
    if (cartBusy || window.FuseCartQuantity.isBusy()) return;
    cartBusy = true;
    cartCheckout.setAttribute('aria-disabled', 'true');
    window.FuseCartQuantity.normalize().then(function () {
      window.location.assign(cartCheckout.href);
    }).catch(function (error) {
      showToast(error.message || 'Could not confirm cart pricing');
      cartBusy = false;
      cartCheckout.removeAttribute('aria-disabled');
      renderCart();
    });
  });

  var cartBtn = document.getElementById('cartBtn');
  var cartClose = document.getElementById('cartClose');
  if (cartBtn) cartBtn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) {
    cartOverlay.addEventListener('click', function (e) { if (e.target === cartOverlay) closeCart(); });
  }
  if (cartBody) {
    // Empty-cart quick add: one tin, one-time, then redraw the drawer.
    cartBody.addEventListener('click', function (e) {
      var add = e.target.closest('[data-add-variant]');
      if (!add || add.disabled || cartBusy || window.FuseCartQuantity.isBusy()) return;
      var buttons = Array.prototype.slice.call(cartBody.querySelectorAll('[data-add-variant]'));
      var originalLabel = add.textContent;
      var feedback = cartBody.querySelector('[data-cart-add-status]');
      var data = new FormData();
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      data.append('id', add.getAttribute('data-add-variant'));
      data.append('quantity', '1');
      cartBusy = true;
      ++renderToken;
      buttons.forEach(function (button) { button.disabled = true; });
      add.textContent = 'Adding…';
      add.setAttribute('aria-busy', 'true');
      cartBody.setAttribute('aria-busy', 'true');
      if (feedback) feedback.hidden = true;
      window.FuseCartQuantity.add(root + 'cart/add.js', data).then(function () {
        return renderCart();
      }).catch(function (error) {
        var message = error.addConfirmed
          ? 'Your item was added, but the cart could not refresh. Check your cart before adding again.'
          : error.transportError ? 'The cart request could not be confirmed. Check your cart before retrying.'
          : error.message || 'Could not add that strip. Please try again.';
        if (feedback && feedback.isConnected) {
          feedback.querySelector('[data-cart-add-status-text]').textContent = message;
          feedback.hidden = false;
        }
        showToast(message);
      }).finally(function () {
        cartBusy = false;
        cartBody.removeAttribute('aria-busy');
        buttons.forEach(function (button) { button.disabled = false; });
        add.textContent = originalLabel;
        add.removeAttribute('aria-busy');
      });
    });
    cartBody.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]');
      if (!b) return;
      var line = b.closest('.cart-line');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var variantId = line.getAttribute('data-variant-id');
      var qtyEl = line.querySelector('.qty span');
      var cur = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var act = b.getAttribute('data-act');
      if (act === 'inc') changeLine(key, cur + 1, act, variantId);
      else if (act === 'dec') changeLine(key, cur - 1, act, variantId);
      else if (act === 'rm') changeLine(key, 0, act, variantId);
    });
  }
  window.Wisp = {
    showToast: showToast, openCart: openCart, updateCartCount: updateCartCount, money: money,
    lockScroll: lockScroll, unlockScroll: unlockScroll, trapFocus: trapFocus
  };

  document.querySelectorAll('a[href^="mailto:sales@takewisp.com"]').forEach(function (a) {
    a.setAttribute('href', 'mailto:sales@takefuse.com');
    if ((a.textContent || '').trim().toLowerCase() === 'sales@takewisp.com') {
      a.textContent = 'sales@takefuse.com';
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartOverlay && cartOverlay.classList.contains('open')) closeCart();
  });

  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var rObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); rObs.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { rObs.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  var navToggle = document.getElementById('navToggle');
  var mobileMenu = document.getElementById('mobileMenu');
  var mmClose = document.getElementById('mmClose');
  var menuUntrap = null;
  function closeMenu() {
    if (!mobileMenu || !mobileMenu.classList.contains('open')) return;
    mobileMenu.classList.remove('open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileMenu.setAttribute('inert', '');
    unlockScroll();
    if (menuUntrap) { menuUntrap(); menuUntrap = null; }
    if (navToggle) { navToggle.setAttribute('aria-expanded', 'false'); navToggle.focus(); }
  }
  if (navToggle && mobileMenu) {
    navToggle.addEventListener('click', function () {
      mobileMenu.classList.add('open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      mobileMenu.removeAttribute('inert');
      lockScroll();
      navToggle.setAttribute('aria-expanded', 'true');
      menuUntrap = trapFocus(mobileMenu);
      if (mmClose) mmClose.focus();
    });
  }
  if (mmClose) mmClose.addEventListener('click', closeMenu);
  if (mobileMenu) mobileMenu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
})();
